import React from 'react';
import './Banner.scss';
import logo from '../../assets/HEM Logo.png';

function Banner() {
  return (
    <div className="banner">
      <img src={logo} alt="Hemgenix Logo" className="logo" />
      <div className="text">
        <h1>THE FIRST AND ONLY FDA-APPROVED GENE THERAPY FOR HEMOPHILIA B</h1>
        <h2>
          Gene Therapy: A Breakthrough Era for Hemophilia B Discover HEMGENIX® (etranacogene
          dezaparvovec-drlb)
        </h2>
      </div>
    </div>
  );
}

export default Banner;
